import { useSiteContent } from '../../../hooks/useSiteContent';

export default function AboutSection() {
  const { content, loading } = useSiteContent();

  if (loading || !content) {
    return (
      <section id="about" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-blue-600 mx-auto"></div>
        </div>
      </section>
    );
  }

  const { about } = content;

  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              {about.about_title}
            </h2>
            {about.about_subtitle && (
              <p className="text-xl text-blue-600 font-semibold mb-4">
                {about.about_subtitle}
              </p>
            )}
            <div className="text-lg text-gray-700 leading-relaxed whitespace-pre-line">
              {about.about_content}
            </div>
          </div>

          <div className="relative">
            {about.about_image ? (
              <img
                src={about.about_image}
                alt={about.about_title}
                className="w-full h-auto rounded-lg shadow-lg"
              />
            ) : (
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-4">
                  <img
                    src="https://readdy.ai/api/search-image?query=professional%20diverse%20marketing%20team%20collaborating%20in%20modern%20office%20with%20laptops%20and%20digital%20screens%20discussing%20strategy%20bright%20natural%20lighting%20clean%20white%20background&width=400&height=500&seq=about001&orientation=portrait"
                    alt="Team collaboration"
                    className="w-full h-64 object-cover object-top rounded-lg shadow-lg"
                  />
                  <img
                    src="https://readdy.ai/api/search-image?query=creative%20web%20designers%20working%20on%20responsive%20website%20layouts%20with%20multiple%20monitors%20showing%20colorful%20UI%20designs%20modern%20workspace%20clean%20background&width=400&height=300&seq=about002&orientation=landscape"
                    alt="Web design"
                    className="w-full h-48 object-cover object-top rounded-lg shadow-lg"
                  />
                </div>
                <div className="space-y-4 pt-8">
                  <img
                    src="https://readdy.ai/api/search-image?query=digital%20marketing%20analytics%20dashboard%20on%20large%20screen%20showing%20growth%20charts%20and%20social%20media%20metrics%20in%20bright%20modern%20office%20professional%20atmosphere%20clean%20background&width=400&height=300&seq=about003&orientation=landscape"
                    alt="Analytics"
                    className="w-full h-48 object-cover object-top rounded-lg shadow-lg"
                  />
                  <img
                    src="https://readdy.ai/api/search-image?query=successful%20business%20meeting%20with%20clients%20shaking%20hands%20celebrating%20project%20success%20in%20contemporary%20office%20space%20natural%20lighting%20clean%20professional%20background&width=400&height=500&seq=about004&orientation=portrait"
                    alt="Client success"
                    className="w-full h-64 object-cover object-top rounded-lg shadow-lg"
                  />
                </div>
              </div>
            )}

            <div className="absolute -bottom-8 -left-8 w-32 h-32 bg-blue-500 rounded-full opacity-20 blur-3xl"></div>
            <div className="absolute -top-8 -right-8 w-32 h-32 bg-purple-500 rounded-full opacity-20 blur-3xl"></div>
          </div>
        </div>

        <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="text-center p-6 bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl">
            <i className="ri-award-line text-4xl text-blue-600 mb-3 w-10 h-10 mx-auto flex items-center justify-center"></i>
            <div className="text-3xl font-bold text-gray-900 mb-2">50+</div>
            <div className="text-gray-600">Premios Ganados</div>
          </div>
          <div className="text-center p-6 bg-gradient-to-br from-purple-50 to-purple-100 rounded-xl">
            <i className="ri-team-line text-4xl text-purple-600 mb-3 w-10 h-10 mx-auto flex items-center justify-center"></i>
            <div className="text-3xl font-bold text-gray-900 mb-2">200+</div>
            <div className="text-gray-600">Clientes Felices</div>
          </div>
          <div className="text-center p-6 bg-gradient-to-br from-green-50 to-green-100 rounded-xl">
            <i className="ri-rocket-line text-4xl text-green-600 mb-3 w-10 h-10 mx-auto flex items-center justify-center"></i>
            <div className="text-3xl font-bold text-gray-900 mb-2">500+</div>
            <div className="text-gray-600">Proyectos Realizados</div>
          </div>
          <div className="text-center p-6 bg-gradient-to-br from-orange-50 to-orange-100 rounded-xl">
            <i className="ri-star-line text-4xl text-orange-600 mb-3 w-10 h-10 mx-auto flex items-center justify-center"></i>
            <div className="text-3xl font-bold text-gray-900 mb-2">4.9/5</div>
            <div className="text-gray-600">Calificación del Cliente</div>
          </div>
        </div>
      </div>
    </section>
  );
}
